(function () {
  function euroFromCents(cents) {
    const n = (Number(cents) || 0) / 100;
    return new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(n);
  }

  function safeParseConfig(raw) {
    try {
      const parsed = JSON.parse(raw);
      if (typeof parsed === "string") return JSON.parse(parsed);
      return parsed;
    } catch (e) {
      console.error("Config parse failed:", e);
      return null;
    }
  }

  const CHECK_SVG = `
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
      stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <path d="M20 6 9 17l-5-5"></path>
    </svg>
  `;

  async function addToCart(items) {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items })
    });

    const contentType = (res.headers.get("content-type") || "").toLowerCase();
    const text = await res.text().catch(() => "");

    if (contentType.includes("text/html") || text.includes("Verifying your connection")) {
      throw new Error("Sicherheitsprüfung aktiv. Bitte Seite neu laden und nochmal versuchen.");
    }

    let body = null;
    try { body = JSON.parse(text); } catch (_) {}

    if (!res.ok) {
      const msg =
        (body && (body.description || body.message)) ||
        text ||
        `HTTP ${res.status}`;
      throw new Error(msg);
    }

    return body;
  }

  function makeGroupId() {
    return "cfg_" + Date.now().toString(36) + "_" + Math.random().toString(36).slice(2, 8);
  }

  function decomposeExact(amount, coinsArr) {
    const amt = Math.max(0, Math.round(Number(amount) || 0));
    const coins = (coinsArr || []).map(Number).filter(n => Number.isFinite(n) && n > 0);

    const best = Array(amt + 1).fill(null);
    best[0] = [];

    for (let i = 1; i <= amt; i++) {
      let candidate = null;

      for (const c of coins) {
        if (c > i) continue;
        const prev = best[i - c];
        if (!prev) continue;

        const next = prev.concat([c]);
        if (!candidate || next.length < candidate.length) candidate = next;
      }

      best[i] = candidate;
    }

    return best[amt];
  }

  function initConfigurator(root) {
    const cfg = safeParseConfig(root.getAttribute("data-config"));
    if (!cfg) return;

    const productHandle = String(root.getAttribute("data-product-handle") || "").toLowerCase();
    const cartUrl = String(root.getAttribute("data-cart-url") || "/cart");

    const widthOverlayEl = root.querySelector("[data-ks-width-overlay]");
    const mainVariantId = Number(root.getAttribute("data-product-variant-id"));
    const freeEngraving = root.getAttribute("data-free-engraving") === "true";
    const variantsJsonEl = root.querySelector("[data-ks-product-variants]");
    let productVariants = [];

    try {
      productVariants = variantsJsonEl ? JSON.parse(variantsJsonEl.textContent || "[]") : [];
      if (!Array.isArray(productVariants)) productVariants = [];
    } catch (e) {
      console.warn("Configurator: product variants could not be parsed", e);
      productVariants = [];
    }

    const stepsEl = root.querySelector("[data-ks-steps]");
    const totalEls = Array.from(root.querySelectorAll("[data-ks-total]"));
    const imgEl = root.querySelector("[data-ks-image]");
    const addBtns = Array.from(root.querySelectorAll("[data-ks-add]"));
    const errEl = root.querySelector("[data-ks-error]");
    const progressTextEls = Array.from(root.querySelectorAll("[data-ks-progress-text]"));
    const progressBarEls = Array.from(root.querySelectorAll("[data-ks-progress-bar]"));

    if (!stepsEl || !imgEl || addBtns.length === 0 || totalEls.length === 0 || !errEl) {
      console.warn("Configurator: required DOM elements missing");
      return;
    }
const productTitle = String(cfg.productName || cfg.title || "").trim();

    const productTitleEl = root.querySelector("[data-ks-product-title]");
    if (productTitle && productTitleEl) productTitleEl.textContent = productTitle;
    const FONT_OPTIONS = [
      { value: "overpass", label: "Overpass", className: "ks-fontOption--overpass" },
      { value: "kalam", label: "Kalam", className: "ks-fontOption--kalam" }
    ];

    const imageCache = new Set();

    function preloadImages(urls) {
      if (!Array.isArray(urls)) return;
      urls.forEach((url) => {
        if (!url || imageCache.has(url)) return;
        imageCache.add(url);
        const im = new Image();
        im.decoding = "async";
        im.loading = "eager";
        im.src = url;
      });
    }

    function setPreviewImage(url) {
      if (!url || !imgEl) return;
      if (imgEl.getAttribute("src") === url) {
        updateEngravingOverlay();
        return;
      }

      imgEl.classList.add("ks-img--fadeout");
      const next = new Image();
      next.decoding = "async";
      next.onload = () => {
        imgEl.src = url;
        imgEl.classList.remove("ks-img--fadeout");
        imgEl.classList.add("ks-img--fadein");
        window.setTimeout(() => imgEl.classList.remove("ks-img--fadein"), 180);

        window.requestAnimationFrame(() => {
          updateEngravingOverlay();
        });
      };
      next.onerror = () => {
        imgEl.src = url;
        imgEl.classList.remove("ks-img--fadeout");

        window.requestAnimationFrame(() => {
          updateEngravingOverlay();
        });
      };
      next.src = url;
    }

    function ensurePreviewWrap() {
      const previewWrap = imgEl.parentElement;
      if (!previewWrap) return null;

      if (getComputedStyle(previewWrap).position === "static") {
        previewWrap.style.position = "relative";
      }

      return previewWrap;
    }

    const state = {
      engraving_font: "overpass"
    };

    let openStepId = null;
    let lastChangedStepId = null;

    function normalizeMatchText(value) {
      return String(value || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "");
    }

    function stepMatchesPatterns(step, patterns) {
      const haystack = normalizeMatchText(`${step && step.id ? step.id : ""} ${step && step.label ? step.label : ""}`);
      return patterns.some(pattern => haystack.includes(normalizeMatchText(pattern)));
    }

    function selectedValueForPatterns(patterns) {
      const step = (cfg.steps || []).find(item => stepMatchesPatterns(item, patterns));
      return step && state[step.id] ? String(state[step.id]) : "";
    }

    function applyMatchingSelectionsFromUrl() {
      if (!productHandle.includes("halsband")) return;

      const params = new URLSearchParams(window.location.search);
      if (params.get("ks_match") !== "1") return;

      const applied = [];
      const mappings = [
        { param: "ks_leather", label: "Lederfarbe", patterns: ["lederfarbe", "leather_color", "leder"] },
        { param: "ks_hardware", label: "Beschläge", patterns: ["beschlage", "beschlag", "karabiner", "ringe", "ring", "schnalle", "hardware", "metall"] }
      ];

      mappings.forEach(mapping => {
        const requested = params.get(mapping.param);
        if (!requested) return;

        const step = (cfg.steps || []).find(item => stepMatchesPatterns(item, mapping.patterns));
        if (!step) return;

        const option = (step.options || []).find(item => normalizeMatchText(item.value) === normalizeMatchText(requested));
        if (!option) return;

        state[step.id] = option.value;
        applied.push(`${mapping.label}: ${option.value}`);
      });

      const notice = root.querySelector("[data-ks-match-notice]");
      if (notice) {
        notice.hidden = false;
        notice.textContent = applied.length
          ? `Passend zur Leine vorausgewählt: ${applied.join(" · ")}. Bitte ergänze jetzt Halsumfang, Breite und Gravur.`
          : "Deine Leine liegt bereits im Warenkorb. Bitte konfiguriere jetzt Halsumfang, Breite und Gravur für das passende Halsband.";
      }

      const backLink = root.querySelector(".ks2__back");
      if (backLink) {
        backLink.href = cartUrl;
        backLink.textContent = "‹ Zurück zum Warenkorb";
      }
    }

    function findStep(stepId) {
      return (cfg.steps || []).find(s => s.id === stepId) || null;
    }

    function findOpt(stepId, value) {
      const step = findStep(stepId);
      if (!step) return null;
      return (step.options || []).find(o => o.value === value) || null;
    }

    function getStepIndex(stepId) {
      return (cfg.steps || []).findIndex(s => s.id === stepId);
    }

    function getDefaultVisualOption(stepId) {
      const defaults = (cfg.imageLogic && cfg.imageLogic.defaultSelections) || {};
      const defaultValue = defaults[stepId];
      if (!defaultValue) return null;
      return findOpt(stepId, defaultValue);
    }

    function getEngravingStep() {
      return (cfg.steps || []).find(step => step.type === "engraving") || null;
    }

    function isEngravingOpen() {
      const engravingStep = getEngravingStep();
      return !!engravingStep && openStepId === engravingStep.id;
    }

function getContainedImageBox(img, container) {
  if (!img || !container) return null;

  const containerWidth = container.clientWidth;
  const containerHeight = container.clientHeight;
  const naturalWidth = img.naturalWidth;
  const naturalHeight = img.naturalHeight;

  if (!containerWidth || !containerHeight || !naturalWidth || !naturalHeight) {
    return null;
  }

  const scale = Math.min(containerWidth / naturalWidth, containerHeight / naturalHeight);
  const width = naturalWidth * scale;
  const height = naturalHeight * scale;

  return {
    left: (containerWidth - width) / 2,
    top: (containerHeight - height) / 2,
    width,
    height
  };
}
    
    function updateWidthOverlay() {
      if (!widthOverlayEl) return;

      if (!cfg.widthOverlays) {
        widthOverlayEl.style.opacity = "0";
        widthOverlayEl.removeAttribute("src");
        return;
      }

      const widthValue = state.width;
      const overlayUrl = widthValue ? cfg.widthOverlays[widthValue] : null;

      if (!overlayUrl) {
        widthOverlayEl.style.opacity = "0";
        widthOverlayEl.removeAttribute("src");
        return;
      }

      if (widthOverlayEl.getAttribute("src") !== overlayUrl) {
        widthOverlayEl.src = overlayUrl;
      }

      widthOverlayEl.style.position = "absolute";
      widthOverlayEl.style.top = "0";
      widthOverlayEl.style.left = "0";
      widthOverlayEl.style.width = "100%";
      widthOverlayEl.style.height = "100%";
      widthOverlayEl.style.objectFit = "contain";
      widthOverlayEl.style.pointerEvents = "none";
      widthOverlayEl.style.opacity = "1";
      widthOverlayEl.style.zIndex = "2";
    }

    function ensureEngravingOverlay() {
      const previewWrap = ensurePreviewWrap();
      if (!previewWrap) {
        return { overlay: null, overlayImg: null, textBox: null, text: null };
      }

      let overlay = root.querySelector("[data-ks-engrave-preview]");
      let overlayImg = root.querySelector("[data-ks-engrave-image]");
      let textBox = root.querySelector("[data-ks-engrave-textbox]");
      let textEl = root.querySelector("[data-ks-engrave-text]");

      if (!overlay) {
        overlay = document.createElement("div");
        overlay.className = "ks2__engravePreview";
        overlay.setAttribute("data-ks-engrave-preview", "");
        overlay.hidden = true;
        previewWrap.appendChild(overlay);
      }

      overlay.style.position = "absolute";
      overlay.style.inset = "0";
      overlay.style.pointerEvents = "none";
      overlay.style.zIndex = "4";
      overlay.style.overflow = "hidden";

      if (!overlayImg) {
        overlayImg = document.createElement("img");
        overlayImg.className = "ks2__engravePreviewImg";
        overlayImg.setAttribute("data-ks-engrave-image", "");
        overlayImg.alt = "";
        overlayImg.setAttribute("aria-hidden", "true");
        overlay.appendChild(overlayImg);
      }

      overlayImg.style.position = "absolute";
      overlayImg.style.top = "0";
      overlayImg.style.left = "0";
      overlayImg.style.width = "100%";
      overlayImg.style.height = "100%";
      overlayImg.style.objectFit = "contain";
      overlayImg.style.pointerEvents = "none";
      overlayImg.style.zIndex = "1";

      if (!textBox) {
        textBox = document.createElement("div");
        textBox.className = "ks2__engraveTextBox";
        textBox.setAttribute("data-ks-engrave-textbox", "");
        overlay.appendChild(textBox);
      }

      textBox.style.position = "absolute";
      textBox.style.pointerEvents = "none";
      textBox.style.zIndex = "2";
      textBox.style.display = "flex";
      textBox.style.alignItems = "center";
      textBox.style.justifyContent = "center";
      textBox.style.overflow = "hidden";

      if (!textEl) {
        textEl = document.createElement("div");
        textEl.className = "ks2__engraveText font-overpass";
        textEl.setAttribute("data-ks-engrave-text", "");
        textEl.textContent = "";
      }

      // WICHTIG: vorhandenen Text immer in die TextBox verschieben
      if (textEl.parentElement !== textBox) {
        textBox.appendChild(textEl);
      }

      textEl.style.display = "block";
      textEl.style.position = "relative";
      textEl.style.pointerEvents = "none";
      textEl.style.whiteSpace = "nowrap";
      textEl.style.textAlign = "center";
      textEl.style.textTransform = "none";
      textEl.style.lineHeight = "1";
      textEl.style.mixBlendMode = "multiply";
      textEl.style.margin = "0";
      textEl.style.transform = "none";

      return { overlay, overlayImg, textBox, text: textEl };
    }

    const engravingOverlayEls = ensureEngravingOverlay();

    function getEngravingOverlayUrl() {
      if (!cfg.engravingPreviewImages) return null;

      const leatherOpt = findOpt("leather_color", state.leather_color);
      if (!leatherOpt || !leatherOpt.imageKey) return null;

      return cfg.engravingPreviewImages[leatherOpt.imageKey] || null;
    }

    function updateEngravingOverlay() {
      const overlay = engravingOverlayEls.overlay;
      const overlayImg = engravingOverlayEls.overlayImg;
      const textBox = engravingOverlayEls.textBox;
      const textEl = engravingOverlayEls.text;

      if (!overlay || !overlayImg || !textBox || !textEl) return;

      const engravingStep = getEngravingStep();
      if (!engravingStep) {
        overlay.hidden = true;
        overlayImg.removeAttribute("src");
        textEl.textContent = "";
        textEl.style.opacity = "0";
        return;
      }

      const txt = (state[engravingStep.id] || "").trim();
      const overlayUrl = getEngravingOverlayUrl();
      const shouldShow = Boolean(overlayUrl && (isEngravingOpen() || txt.length > 0));

      if (!shouldShow) {
        overlay.hidden = true;
        overlayImg.removeAttribute("src");
        textEl.textContent = "";
        textEl.style.opacity = "0";
        return;
      }

      if (overlayImg.getAttribute("src") !== overlayUrl) {
        overlayImg.src = overlayUrl;
      }

      overlay.hidden = false;

      // Textbereich auf dem unteren Lederstreifen
      // Prozentwerte relativ zur gesamten Preview
     const rect = imgEl.getBoundingClientRect();

const boxWidth = rect.width;
const boxHeight = rect.height;
// Gravur relativ zur tatsächlich gerenderten Overlay-Grafik berechnen
const previewWrap = ensurePreviewWrap();
const overlayBox = getContainedImageBox(overlayImg, previewWrap);

if (!overlayBox) return;

// Diese Werte einmal sauber auf deinem Overlay ausrichten
// relativ zur Overlay-Grafik, NICHT zur gesamten Preview
const engravingArea = {
  x: 0.475, // Mitte des Textbereichs
  y: 0.735, // vertikale Position
  w: 0.4,  // Breite des Textbereichs
  h: 0.13   // Höhe des Textbereichs
};

// Position in echten Pixeln innerhalb der gerenderten Overlay-Grafik
const leftPx = overlayBox.left + (overlayBox.width * engravingArea.x);
const topPx = overlayBox.top + (overlayBox.height * engravingArea.y);
const widthPx = overlayBox.width * engravingArea.w;
const heightPx = overlayBox.height * engravingArea.h;

textBox.style.left = leftPx + "px";
textBox.style.top = topPx + "px";
textBox.style.width = widthPx + "px";
textBox.style.height = heightPx + "px";
textBox.style.transform = "translate(-50%, -50%)";

const isMobile = window.innerWidth < 768;

if (isMobile) {
  textBox.style.setProperty("font-size", "18px", "important");
} else {
  textBox.style.setProperty("font-size", "24px", "important");
}

// Text erbt Größe von Box
textEl.style.setProperty("font-size", "inherit", "important");

      textEl.classList.remove("font-overpass", "font-kalam");
      textEl.classList.add(`font-${state.engraving_font || "overpass"}`);
      textEl.textContent = txt || "";
      textEl.style.opacity = txt.length > 0 ? "0.95" : "0";
      textEl.style.maxWidth = "100%";
      textEl.style.overflow = "hidden";
      textEl.style.textOverflow = "ellipsis";
      textEl.style.fontSize = "26px";
      textEl.style.letterSpacing = "0.02em";
      textEl.style.color = "rgba(60, 35, 20, 0.75)";
textEl.style.textShadow = `
  0 1px 0 rgba(255,255,255,0.15),
  0 -1px 0 rgba(0,0,0,0.35),
  0 0 2px rgba(0,0,0,0.25)
`;
textEl.style.mixBlendMode = "multiply";
    }

    if (imgEl) {
      imgEl.addEventListener("load", () => {
        updateEngravingOverlay();
      });
    }

    window.addEventListener("resize", () => {
      updateEngravingOverlay();
    });

    function isStepComplete(step) {
      if (!step.required) {
        if (step.type === "engraving") return Boolean((state[step.id] || "").trim());
        return Boolean(state[step.id]);
      }
      if (step.type === "engraving") return true;
      return Boolean(state[step.id]);
    }

    function requiredOk() {
      return (cfg.steps || []).every(step => {
        if (!step.required) return true;
        if (step.type === "engraving") return true;
        return Boolean(state[step.id]);
      });
    }

    function calcSurchargeCents() {
      let delta = 0;

      (cfg.steps || []).forEach(step => {
        if (step.type === "engraving") {
          const val = (state[step.id] || "").trim();
          if (val.length > 0 && !freeEngraving) delta += Number(step.priceDeltaIfFilledCents || 0);
          return;
        }

        const val = state[step.id];
        if (!val) return;

        const opt = findOpt(step.id, val);
        if (opt && opt.priceDeltaCents) delta += Number(opt.priceDeltaCents);
      });

      return Math.round(Number(delta) || 0);
    }

    function getSelectedVisualOptions() {
      const arr = [];
      const selectedStepIds = new Set();
      const compoundSteps = (cfg.imageLogic && cfg.imageLogic.compoundSteps) || [];

      (cfg.steps || []).forEach((step, index) => {
        if (step.type === "engraving") return;
        if (compoundSteps.length && !compoundSteps.includes(step.id)) return;

        const val = state[step.id];
        if (!val) return;

        const opt = findOpt(step.id, val);
        if (!opt || !opt.imageKey) return;

        arr.push({
          stepId: step.id,
          stepIndex: index,
          imageKey: opt.imageKey,
          injected: false
        });

        selectedStepIds.add(step.id);
      });

      compoundSteps.forEach((stepId) => {
        if (selectedStepIds.has(stepId)) return;

        const opt = getDefaultVisualOption(stepId);
        if (!opt || !opt.imageKey) return;

        arr.push({
          stepId,
          stepIndex: getStepIndex(stepId),
          imageKey: opt.imageKey,
          injected: true
        });
      });

      return arr;
    }

    function uniqueByImageKey(items) {
      const seen = new Set();
      const out = [];

      items.forEach(item => {
        if (!item || !item.imageKey || seen.has(item.imageKey)) return;
        seen.add(item.imageKey);
        out.push(item);
      });

      return out;
    }

    function reorderSelectedOptions(items) {
      const arr = [...items];

      arr.sort((a, b) => {
        if (a.stepId === lastChangedStepId && b.stepId !== lastChangedStepId) return -1;
        if (b.stepId === lastChangedStepId && a.stepId !== lastChangedStepId) return 1;

        if (a.injected && !b.injected) return 1;
        if (b.injected && !a.injected) return -1;

        return a.stepIndex - b.stepIndex;
      });

      return uniqueByImageKey(arr);
    }

    function getAllNonEmptySubsets(items) {
      const result = [];
      const n = items.length;
      const total = Math.pow(2, n);

      for (let mask = 1; mask < total; mask++) {
        const subset = [];
        for (let i = 0; i < n; i++) {
          if (mask & (1 << i)) subset.push(items[i]);
        }
        result.push(subset);
      }

      result.sort((a, b) => b.length - a.length);
      return result;
    }

    function permutations(arr) {
      if (arr.length <= 1) return [arr];

      const out = [];
      for (let i = 0; i < arr.length; i++) {
        const head = arr[i];
        const rest = arr.slice(0, i).concat(arr.slice(i + 1));
        const tailPerms = permutations(rest);
        tailPerms.forEach(p => out.push([head, ...p]));
      }
      return out;
    }

    function buildCandidateImageKeysFromSelected(selectedItems) {
      const candidates = [];
      const seen = new Set();

      function pushKey(key) {
        if (!key || seen.has(key)) return;
        seen.add(key);
        candidates.push(key);
      }

      const ordered = reorderSelectedOptions(selectedItems);
      const subsets = getAllNonEmptySubsets(ordered);

      subsets.forEach(subset => {
        const perms = permutations(subset);
        perms.forEach(perm => {
          pushKey(perm.map(x => x.imageKey).join("__"));
        });
      });

      ordered.forEach(item => pushKey(item.imageKey));
      pushKey("default");

      return candidates;
    }

    function pickPreviewImageKey() {
      const selectedItems = getSelectedVisualOptions();
      const candidates = buildCandidateImageKeysFromSelected(selectedItems);

      for (const key of candidates) {
        if (key === "default" && cfg.images && cfg.images.default) return "default";
        if (cfg.images && cfg.images[key]) return key;
      }

      return null;
    }

    function nextIncompleteStepId() {
      const steps = cfg.steps || [];
      for (const s of steps) {
        if (s.required && s.type !== "engraving" && !state[s.id]) return s.id;
      }
      return steps.length ? steps[steps.length - 1].id : null;
    }

    function renderOptionButton(step, opt) {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "ks-option" + (step.type === "swatches" ? " ks-option--swatch" : "");
      btn.setAttribute("aria-pressed", state[step.id] === opt.value ? "true" : "false");

      if (step.type === "swatches") {
        const sw = document.createElement("span");
        sw.className = "ks-swatch";
        if (opt.swatch) sw.style.background = opt.swatch;
        btn.appendChild(sw);
      }

      const labelWrap = document.createElement("span");
labelWrap.className = "ks-option__text";

const label = document.createElement("span");
label.textContent = opt.value;
labelWrap.appendChild(label);

if (opt.tag) {
  const tag = document.createElement("span");
  tag.className = "ks-option__tag";
  tag.textContent = opt.tag;
  labelWrap.appendChild(tag);
}

btn.appendChild(labelWrap);

      if (Number(opt.priceDeltaCents || 0) > 0) {
        const price = document.createElement("span");
        price.className = "ks-option__price";
        price.textContent = `+${euroFromCents(Number(opt.priceDeltaCents))}`;
        btn.appendChild(price);
      }

      btn.addEventListener("click", () => {
        state[step.id] = opt.value;
        lastChangedStepId = step.id;
        if (step.required) openStepId = nextIncompleteStepId() || step.id;
        render();
      });

      return btn;
    }

    function openLightbox(url) {
      if (!url) return;
      const overlay = document.createElement("div");
      overlay.className = "ks-lightbox";
      overlay.innerHTML = `
        <div class="ks-lightbox__inner" role="dialog" aria-label="Bild vergrößern">
          <img src="${url}" alt="Vorschau vergrößert" />
        </div>
      `;
      overlay.addEventListener("click", () => overlay.remove());
      document.body.appendChild(overlay);
    }

    if (!imgEl.dataset.ksLightboxBound) {
      imgEl.dataset.ksLightboxBound = "1";
      imgEl.style.cursor = "zoom-in";
      imgEl.addEventListener("click", () => {
        const url = imgEl.getAttribute("src");
        if (url) openLightbox(url);
      });
    }

    function renderStep(step, index) {
      const wrap = document.createElement("div");
      wrap.className = "ks-step";
      const isOpen = (openStepId === step.id);
      wrap.dataset.open = isOpen ? "true" : "false";

      const head = document.createElement("button");
      head.type = "button";
      head.className = "ks-step__head";

      const left = document.createElement("div");
      left.className = "ks-step__left";

      const num = document.createElement("div");
      num.className = "ks-step__num";

      const complete = isStepComplete(step);
      if (complete && !isOpen) {
        num.classList.add("ks-step__num--done");
        num.textContent = "✓";
      } else {
        num.textContent = String(index + 1);
      }
      left.appendChild(num);

      const name = document.createElement("div");
      name.className = "ks-step__name";
      name.textContent = step.label + (step.required ? " *" : "");
      left.appendChild(name);

      head.appendChild(left);

      const stateEl = document.createElement("div");
      stateEl.className = "ks-step__state";

      function getStepSummary(step) {
        if (step.type === "engraving") {
          const v = (state[step.id] || "").trim();
          return v ? v : null;
        }
        const v = state[step.id];
        return v ? String(v) : null;
      }

      const summary = getStepSummary(step);

      if (summary) {
        const check = document.createElement("span");
        check.className = "ks-step__check";
        check.innerHTML = CHECK_SVG;
        stateEl.appendChild(check);

        const txt = document.createElement("span");
        txt.textContent = summary;
        stateEl.appendChild(txt);
      } else {
        const txt = document.createElement("span");
        txt.textContent = "Auswählen";
        stateEl.appendChild(txt);
      }

      head.appendChild(stateEl);

      head.addEventListener("click", () => {
        openStepId = (openStepId === step.id) ? null : step.id;
        render();
      });

      wrap.appendChild(head);

      const body = document.createElement("div");
      body.className = "ks-step__body";

      if (step.type === "engraving") {
        const input = document.createElement("input");
        input.className = "ks-input";
        input.type = "text";
        input.maxLength = Number.isFinite(Number(step.maxLength)) ? Number(step.maxLength) : 20;
        input.placeholder = step.placeholder || "";
        input.value = state[step.id] || "";

        input.id = "ks-engraving";
        input.name = "ks-engraving";

        input.addEventListener("input", () => {
          state[step.id] = input.value;
          lastChangedStepId = step.id;
          renderPriceAndPreview();
        });

        body.appendChild(input);

        const fontWrap = document.createElement("div");
        fontWrap.className = "ks-fonts";

        const fontLabel = document.createElement("div");
        fontLabel.className = "ks-fonts__label";
        fontLabel.textContent = "Schriftart auswählen";
        fontWrap.appendChild(fontLabel);

        const fontOptions = document.createElement("div");
        fontOptions.className = "ks-options";

        FONT_OPTIONS.forEach((font) => {
          const btn = document.createElement("button");
          btn.type = "button";
          btn.className = `ks-option ${font.className}`;
          btn.setAttribute("aria-pressed", state.engraving_font === font.value ? "true" : "false");
          btn.textContent = font.label;

          btn.addEventListener("click", () => {
            state.engraving_font = font.value;
            renderPriceAndPreview();
            render();
          });

          fontOptions.appendChild(btn);
        });

        fontWrap.appendChild(fontOptions);
        body.appendChild(fontWrap);

        const hint = document.createElement("div");
        hint.className = "ks-muted";
        hint.textContent = freeEngraving
          ? "Gratis-Gravur – der Aktionspreis ist bereits berücksichtigt."
          : `+${euroFromCents(Number(step.priceDeltaIfFilledCents || 0))}`;
        body.appendChild(hint);

        wrap.appendChild(body);
        return wrap;
      }

      const opts = document.createElement("div");
      opts.className = "ks-options";
      (step.options || []).forEach(opt => opts.appendChild(renderOptionButton(step, opt)));
      body.appendChild(opts);

      wrap.appendChild(body);
      return wrap;
    }

    function renderPriceAndPreview() {
      const base = Number(cfg.basePriceCents || 0);
      const delta = calcSurchargeCents();
      const totalTxt = euroFromCents(base + delta);

      totalEls.forEach(el => (el.textContent = totalTxt));

      const imgKey = pickPreviewImageKey();
      const imgUrl = imgKey && cfg.images ? cfg.images[imgKey] : null;
      if (imgUrl) setPreviewImage(imgUrl);

      updateWidthOverlay();
      updateEngravingOverlay();

      const ok = requiredOk();
      const requiredSteps = (cfg.steps || []).filter(step => step.required && step.type !== "engraving");
      const completedSteps = requiredSteps.filter(step => Boolean(state[step.id])).length;
      const remainingSteps = Math.max(requiredSteps.length - completedSteps, 0);
      const progress = requiredSteps.length ? Math.round((completedSteps / requiredSteps.length) * 100) : 100;

      progressTextEls.forEach(el => {
        el.textContent = ok ? "Auswahl vollständig" : `${completedSteps} von ${requiredSteps.length} gewählt`;
      });
      progressBarEls.forEach(el => {
        el.style.width = `${progress}%`;
      });
      addBtns.forEach(btn => {
        btn.disabled = !ok;
        if (!btn.dataset.ksAdding) {
          btn.textContent = ok
            ? "In den Warenkorb"
            : (remainingSteps === requiredSteps.length ? "Auswahl starten" : `Noch ${remainingSteps} Auswahl${remainingSteps === 1 ? "" : "en"}`);
        }
      });
      errEl.textContent = "";
    }

    async function handleAdd() {
      errEl.textContent = "";

      if (!requiredOk()) {
        errEl.textContent = "Bitte alle Pflichtfelder auswählen.";
        openStepId = nextIncompleteStepId();
        render();
        return;
      }

      const groupId = makeGroupId();

       const currentImgKey = pickPreviewImageKey();
const currentImgUrl = currentImgKey && cfg.images ? cfg.images[currentImgKey] : null;

const props = {
  _ks_group: groupId,
  _ks_configured: "1"
};

if (currentImgUrl) {
  props["_ks_cart_image"] = currentImgUrl;
}

      (cfg.steps || []).forEach(step => {
        if (step.type === "engraving") {
          const v = (state[step.id] || "").trim();
          if (v) {
            props["Gravur"] = v;
            props["Schriftart Gravur"] = state.engraving_font === "kalam" ? "Kalam" : "Overpass";
            if (freeEngraving) props["Aktion"] = "Gratis Gravur";
          }
          return;
        }
        if (state[step.id]) props[step.label] = state[step.id];
      });

      const delta = calcSurchargeCents();
      const finalPriceCents = Number(cfg.basePriceCents || 0) + delta;

      // Wenn im Shopify-Produkt Preisvarianten mit dem exakten Endpreis angelegt sind,
      // wird nur eine einzige, sauber bepreiste Produktzeile in den Checkout gelegt.
      // Ohne passende Preisvariante bleibt die bewährte Aufpreis-Zerlegung als Fallback aktiv.
      const exactPriceVariant = productVariants.find((variant) => {
        return variant && variant.available !== false && Number(variant.price) === finalPriceCents;
      });

      if (exactPriceVariant && Number(exactPriceVariant.id) !== mainVariantId) {
        props["_ks_pricing_mode"] = "price_variant";
      }

      const map = (cfg.surcharges && cfg.surcharges.variantByCents) ? cfg.surcharges.variantByCents : {};
      const coins = Object.keys(map).map(Number).filter(n => n > 0).sort((a, b) => b - a);

      const combo = exactPriceVariant ? [] : decomposeExact(delta, coins);
      if (!combo) {
        errEl.textContent = "Aufpreis kann nicht exakt dargestellt werden. Bitte Aufpreis-Stufen prüfen.";
        return;
      }

      const surchargeItems = combo.map((c) => ({
        id: Number(map[String(c)]),
        quantity: 1,
        properties: {
          _ks_group: groupId,
          _ks_surcharge: "1"
        }
      }));

      const items = [
        { id: Number(exactPriceVariant ? exactPriceVariant.id : mainVariantId), quantity: 1, properties: props },
        ...surchargeItems
      ];

      addBtns.forEach(btn => {
        btn.disabled = true;
        btn.dataset._oldText = btn.textContent;
        btn.dataset.ksAdding = "true";
        btn.textContent = "Wird hinzugefügt…";
      });

      try {
        await addToCart(items);
        const upsell = root.querySelector("[data-ks-upsell]");
        const collarLink = root.querySelector("[data-ks-upsell-collar]");

        if (upsell && collarLink && !productHandle.includes("halsband")) {
          const collarUrl = new URL("/products/faehrtenband-halsband-konfigurator", window.location.origin);
          collarUrl.searchParams.set("ks_match", "1");

          const leather = selectedValueForPatterns(["lederfarbe", "leather_color", "leder"]);
          const hardware = selectedValueForPatterns(["beschlage", "beschlag", "karabiner", "ringe", "ring", "schnalle", "hardware", "metall"]);
          if (leather) collarUrl.searchParams.set("ks_leather", leather);
          if (hardware) collarUrl.searchParams.set("ks_hardware", hardware);

          collarLink.href = collarUrl.pathname + collarUrl.search;
          upsell.hidden = false;
          collarLink.focus();
        } else {
          window.location.href = cartUrl;
        }
      } catch (e) {
        console.error(e);
        errEl.textContent = "Fehler: " + (e && e.message ? e.message : "Unbekannt");
      } finally {
        addBtns.forEach(btn => {
          btn.disabled = !requiredOk();
          btn.textContent = btn.dataset._oldText || "In den Warenkorb";
          delete btn.dataset._oldText;
          delete btn.dataset.ksAdding;
        });
        renderPriceAndPreview();
      }
    }

    function render() {
      if (!openStepId) openStepId = nextIncompleteStepId() || (cfg.steps?.[0]?.id ?? null);

      stepsEl.innerHTML = "";
      (cfg.steps || []).forEach((step, i) => stepsEl.appendChild(renderStep(step, i)));
      renderPriceAndPreview();
    }

    addBtns.forEach(btn => btn.addEventListener("click", handleAdd));

    applyMatchingSelectionsFromUrl();

    if (cfg.images && cfg.images.default) {
      setPreviewImage(cfg.images.default);
    } else {
      const imgKey = pickPreviewImageKey();
      const imgUrl = imgKey && cfg.images ? cfg.images[imgKey] : null;
      if (imgUrl) setPreviewImage(imgUrl);
    }

    try {
      const allUrls = [];
      if (cfg.images) {
        allUrls.push(...Object.values(cfg.images).filter(v => typeof v === "string"));
      }
      if (cfg.engravingPreviewImages) {
        allUrls.push(...Object.values(cfg.engravingPreviewImages).filter(v => typeof v === "string"));
      }
      preloadImages(allUrls);
    } catch (e) {}

    render();
  }

  (function () {
    function isFormEl(el) {
      return el && el.matches("input, textarea, select");
    }

    document.addEventListener("focusin", (e) => {
      if (!isFormEl(e.target)) return;
      const root = e.target.closest(".ks2");
      if (!root) return;
      root.classList.add("ks2--kbd");
    }, true);

    document.addEventListener("focusout", (e) => {
      if (!isFormEl(e.target)) return;
      const root = e.target.closest(".ks2");
      if (!root) return;

      setTimeout(() => {
        root.classList.remove("ks2--kbd");
        window.scrollTo({ top: window.scrollY, behavior: "auto" });
      }, 150);
    }, true);
  })();

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".ks2").forEach(initConfigurator);
  });
})();
